import React from 'react';
import './hotels.scss';
import { translate } from "react-translate";
import { Row, Col } from "react-bootstrap";

import hotel1 from '../../../images/hotel1.jpg';
import hotel2 from '../../../images/hotel2.jpg';
import hotel3 from '../../../images/hotel3.jpg';
import hotel4 from '../../../images/hotel4.jpg';
import hotel5 from '../../../images/hotel5.jpg';
import hotel6 from '../../../images/hotel6.jpg';

class Hotels extends React.Component {

  render() {
    return (
      <div className="component hotels">
        <div className="content">
          <h4 className="block_title capsFont">{ this.props.t('hotels') }</h4>

          <div className="list">
            <Row>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel5} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/holiday-inn-tbilisi.en-gb.html" target="_blank">Holiday Inn Tbilisi</a>
              </Col>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel6} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/best-western-city-center.en-gb.html" target="_blank">Best Western Tbilisi City Center</a>
              </Col>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel1} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/shota-rustaveli-boutique.en-gb.html" target="_blank">Shota @ Rustaveli Boutique Hotel</a>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>&nbsp;</Col>
            </Row>
            <Row>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel2} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/ezo-t-39-bilisi.en-gb.html" target="_blank">EZO Hotel</a>
              </Col>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel3} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/iota-tbilisi.en-gb.html" target="_blank">IOTA Hotel Tbilisi</a>
              </Col>
              <Col lg={4}>
                <div className="hotel_image">
                  <img src={hotel4} alt="hotel" />
                </div>
                <a className="hotel_name" rel="noopener noreferrer" href="https://www.booking.com/hotel/ge/vinotel.en-gb.html" target="_blank">Vinotel Boutique Hotel</a>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

}

export default translate('Hotels')(Hotels);
